export default __webpack_public_path__ + "static/media/pub1.e0e1ce27.svg";